export default __webpack_public_path__ + "static/kr_system_logo-2cfd55a47ee61735e3b471492cce4489.jpg";